import { TranslationKey } from "../i18n/translation-key"

export enum ElectricBikeRequirement {
  REQUIRES_ELECTRIC = "REQUIRES_ELECTRIC",
  REQUIRES_NON_ELECTRIC = "REQUIRES_NON_ELECTRIC",
  NO_REQUIREMENT = "NO_REQUIREMENT",
}

const ELECTRIC_BIKE_REQUIREMENT_LABEL_KEYS: Record<
  ElectricBikeRequirement,
  TranslationKey
> = {
  [ElectricBikeRequirement.REQUIRES_ELECTRIC]:
    "common.electricBikeRequirement.requiresElectric",
  [ElectricBikeRequirement.REQUIRES_NON_ELECTRIC]:
    "common.electricBikeRequirement.requiresNonElectric",
  [ElectricBikeRequirement.NO_REQUIREMENT]:
    "common.electricBikeRequirement.noRequirement",
}

export class ElectricBikeRequirementMapper {
  static toLabelKey(requirement: ElectricBikeRequirement): TranslationKey {
    return ELECTRIC_BIKE_REQUIREMENT_LABEL_KEYS[requirement]
  }
}
